module.exports = __webpack_public_path__ + "app/assets/images/man6-da87be30e9caa884e2ecacc920d53475.jpg";